import { TGetNoticeResponse } from 'types/apis/notice';
import { TRegisterNoticeForm } from 'types/form/notice';

export const NoticeInfoDefaultValues: TGetNoticeResponse = {
  writerId: null,
  writerRole: '',
  title: '',
  content: '',
  createdAt: '',
  noticeFileList: [],
  prevNoticeId: null,
  nextNoticeId: null,
};

export const NoticeRegisterDefaultValues: TRegisterNoticeForm = {
  title: '',
  content: '',
};

export const NoticeEditDefaultValues: TRegisterNoticeForm = {
  title: '',
  content: '',
  deleteFileIdList: [],
};
